<template>
  <div id="overlay">
    <div id="info" class="p-3 pt-4 pb-4 shadow">
      <img id="image" :src="image_path" class="mb-3"/>
      <h3>{{ translations.header }}</h3>
      <p>{{ translations.description }}</p>
      <h4>{{ translations.question }}</h4>
      <div class="row mt-2 mt-sm-4">
        <div class="col-xs-24 col-sm-12">
          <button class="btn btn-primary-link btn-lg" @click="back">{{ translations.false }}</button>
        </div>
        <div class="col-xs-24 col-sm-12">
          <form ref="form" :action="action" method="post">
            <input type="hidden" :value="token" name="authenticity_token" />
            <button class="btn btn-primary btn-lg">{{ translations.true }}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.querySelector(".sw-Body_Inner").classList.add("sw-Body-blurred");
  },
  name: "AdultContentWarning",
  props: {
    image_path: {
      required: true,
      type: String
    },
    token: {
      required: true,
      type: String
    },
    action: {
      required: true,
      type: String
    },
    translations: {
      required: true,
      type: Object
    }
  },
  methods: {
    back() {
      window.history.back();
    }
  },
};
</script>

<style scoped>
  #image {
    width: 150px;
    height: 150px;
  }

  #overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    display: grid;
    place-items: center center;

    /* edge */
    justify-content: center;
    align-items: center;
  }

  #info {
    width: 100%;
    max-width: 550px;
    background: white;
    text-align: center;
  }
</style>
